import { NgIf } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormHelper } from '@common/form-helper';
import { CardComponent } from '@components/card/card.component';
import { ConsultationRequestService } from '@services/consultation-request.service';
import { FormService } from '@services/form.service';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-consultation-request-contact-information',
  templateUrl: './contact-information.component.html',
  styleUrls: ['./contact-information.component.scss'],
  imports: [CardComponent, FormsModule, ReactiveFormsModule, NgIf, NgxMaskDirective],
})
export class ContactInformationComponent extends FormHelper implements OnInit {
  public contactInfoForm: FormGroup;

  private formService = inject(FormService);
  private consultationRequestService = inject(ConsultationRequestService);

  public ngOnInit(): void {
    this.contactInfoForm = this.formService.consultationRequest.get('contact') as FormGroup;
    if (this.consultationRequestService.consultationOrderDetail) {
      this.prefillContactInformation();
    }
  }

  /**
   * Determines if a form control is invalid.
   *
   * @param {string} controlName The name of the form control to check for validity.
   */
  public invalidControl(controlName: string): boolean {
    return this.isInvalid(this.contactInfoForm.get(controlName));
  }

  /**
   * Determines if contacted by phone message is shown
   */
  public showContactedByPhoneMessage(): boolean {
    return this.consultationRequestService.consultationForm
      .get('contact')
      .get('phone')
      .hasValidator(Validators.required);
  }

  /**
   * Fill form personal information form fields
   */
  private prefillContactInformation() {
    this.contactInfoForm.patchValue({
      email: this.consultationRequestService.consultationOrderDetail.email,
      phone: this.consultationRequestService.consultationOrderDetail.phone,
    });
  }
}
